
export const OpenData = [
    // {
    //     projectName: 'CRYPTO_CHECKER',
    //     projectDescription:
    //         'Do you want to invest in crypto? Now you can !! Check how the crytocurrencies are going...',
    //     imageUrl: 'https://i.postimg.cc/jShgGqKd/crypto.png',

    //     projectUrl: '',
    // },
    {
        projectName: 'CollegeSpace',
        projectDescription:
            'CollegeSpace, the Socio-Academic Portal of NSUT, is the most frequently visited website of NSUT. We aim to make the life of every NSUTian simpler & turn these four years into a smoother ride!',
        imageUrl: 'https://i.ibb.co/dWcm8xq/collegespace.png',

        projectUrl: '',
    },
    {
        projectName: 'Girl Script Winter Of Coding',
        projectDescription:
            'GirlScript is a non-profit organization that encourages diversity in technical education by providing reservations for women and underrepresented groups in society.It started as a project but eventually gained enormous momentum to become India First and Biggest Technical Community.',
        imageUrl: 'https://i.ibb.co/WPs8Rcb/GWOC.png',

        projectUrl: '',
    },
    {
        projectName: 'Techncrats',
        projectDescription:
            'College Society',
        imageUrl: 'https://i.ibb.co/khXg5sL/79038016.png',

        projectUrl: '',
    }

];
